import { render, staticRenderFns } from "./ValuesHeader.vue?vue&type=template&id=617afeec&"
import script from "./ValuesHeader.vue?vue&type=script&lang=js&"
export * from "./ValuesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ValuesHeader.vue?vue&type=style&index=0&id=617afeec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports